import { motion } from 'framer-motion';
import { FiCheck, FiStar } from 'react-icons/fi';

const PRICING_FEATURES = [
  'Unlimited goal tracking',
  'Daily check-ins & reminders',
  'Progress analytics',
  'Priority support'
];

const PricingStep = ({ onNext, onBack }) => {
  return (
    <motion.div
      className="onboarding-step pricing-step"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
    >
      <div className="pricing-content">
        <div className="pricing-header">
          <h2>Start Your Journey</h2>
          <p className="step-description">
            Begin with a 14-day free trial
          </p>
        </div>

        <motion.div 
          className="pricing-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <div className="pricing-card-header">
            <div className="trial-badge">
              14 days free trial
            </div>
            <h3>Pro Plan</h3>
            <div className="pricing-amount">
              <span className="currency">$</span>
              <span className="amount">4.99</span>
              <span className="period">/month</span>
            </div>
          </div>

          <div className="pricing-features">
            {PRICING_FEATURES.map((feature, index) => (
              <motion.div 
                key={index}
                className="feature-item"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 + (index * 0.1) }}
              >
                <FiCheck className="check-icon" />
                <span>{feature}</span>
              </motion.div>
            ))}
          </div>

          <div className="pricing-note">
            Cancel anytime • No commitment
          </div>
        </motion.div>

        <div className="step-buttons">
          <button 
            className="onboarding-btn secondary"
            onClick={onBack}
          >
            Back
          </button>
          <button 
            className="onboarding-btn"
            onClick={onNext}
          >
            Start Free Trial
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default PricingStep;
